import cs from 'classnames';

import Popover from '../Popovers/Popover/Popover';

/**
 * @param {import('./lib/propTypes').InputOptionsProps} props
 */

const InputOptions = ({
  options = [],
  currentOption = null,
  onClickOption,
  position = 'bottom',
  className,
  panelClassName,
  disabled
}) => {
  return (
    <Popover
      isFixed
      isDropdown
      icon={false}
      position={position}
      disabled={disabled}
      text={currentOption}
      options={options}
      onOptionClick={(option) => onClickOption(option?.value)}
      dataQa="popover-open"
      className={cs(
        'flex items-center !rounded-[4px] bg-neutral-100  hover:bg-neutral-200',
        className
      )}
      activeClassNames={{ button: open ? '!bg-primary-700' : '' }}
      buttonClassName="!min-h-[28px] bg-transparent hover:bg-transparent"
      textClassName="text-neutral-600"
      panelClassName={cs('min-w-fit', panelClassName)}
    />
  );
};

export default InputOptions;
